export default __webpack_public_path__ + "assets/cf0918.jpg";